module.exports = __webpack_public_path__ + "img/01_BC1_normal_isnt.abaff44d.jpg";